import { c as _c } from "react/compiler-runtime";
export default function CreateWaveOutcomesWinnersAddWinner(t0) {
  const $ = _c(4);
  const {
    addWinner
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <svg className="tw-h-5 tw-w-5 tw-mr-2 tw-flex-shrink-0" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    t2 = <span>Add winner</span>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== addWinner) {
    t3 = <div className="tw-flex -tw-ml-2"><button onClick={addWinner} type="button" className={"tw-py-1 tw-px-2 tw-bg-transparent tw-border-0 tw-flex tw-items-center tw-text-sm tw-text-primary-400 hover:tw-text-primary-300 \n tw-font-semibold tw-transition tw-duration-300 tw-ease-out"}>{t1}{t2}</button></div>;
    $[2] = addWinner;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}